import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  QueryList,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import {
  SearchRequest,
  SimpleNavigation,
  SimpleRefinementItem,
} from '@usf/product-types';
import { FilterRequestModel } from '../../../../shared/models/filter-request-model';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import {
  DISCLAIMER_HEIGHT,
  DISCLAIMER_WIDTH,
} from 'src/app/search/shared/constants/search-config';
import { isValidRefinement } from 'src/app/search/utils/search-filter.util';
import { FilterNavType } from 'src/app/search/models/filter-nav-type.enum';
import { SearchFilterSelected } from '@search/shared/models/search-filter-selected';
import { SearchFilterService } from 'src/app/search/services/search-filter.service';

@Component({
  selector: 'app-refinement-menu',
  templateUrl: './refinement-menu.component.html',
  styleUrls: ['./refinement-menu.component.scss'],
})
export class RefinementMenuComponent implements OnInit {
  @Input() filterNav: SimpleNavigation;
  @Input() searchRequest: SearchRequest;
  @Output()
  selectFilterOption: EventEmitter<FilterRequestModel> = new EventEmitter();
  filterRefinements: SimpleRefinementItem[];
  @ViewChildren('categoryIds') categoryLinks: QueryList<ElementRef>;
  @ViewChild('triangle') triangle: any;
  @ViewChild('disclaimerDialog') dialogTemplate: TemplateRef<any>;
  timer: any;
  DEFAULT_SHOW = 10;
  itemsToShow = this.DEFAULT_SHOW;

  filterNavType = FilterNavType;

  constructor(
    private dialog: MatDialog,
    private renderer: Renderer2,
    private searchFilterService: SearchFilterService,
  ) {}

  @HostListener('document:click', ['$event'])
  clickedOut(event) {
    const informationIcon = document.getElementsByName(
      'information-circle-outline',
    )[0];
    if (
      !informationIcon?.contains(event.target) &&
      this.dialogTemplate?.elementRef?.nativeElement
    ) {
      this.hideDisclaimer();
    }
  }

  ngOnInit(): void {
    this.filterRefinements = this.filterNav?.refinements?.filter(r =>
      isValidRefinement(
        this.searchRequest?.searchFilterProperties,
        this.filterNav,
        r,
      ),
    );
  }

  selectMenuItems(item: SimpleRefinementItem, categoryLink: boolean) {
    const selectedOuterDiv = this.categoryLinks
      .toArray()
      .filter(a => +a.nativeElement.id === item.dimensionId)[0];
    const selected =
      !!selectedOuterDiv &&
      !selectedOuterDiv.nativeElement.classList.contains('selected');

    if (selected) {
      this.renderer.addClass(selectedOuterDiv.nativeElement, 'selected');
    } else {
      this.renderer.removeClass(selectedOuterDiv.nativeElement, 'selected');
    }

    let searchItems = this.searchRequest.searchFilterProperties || '';
    if (selected) {
      if (!categoryLink) {
        searchItems = !!this.searchRequest.searchFilterProperties
          ? `${
              this.searchRequest.searchFilterProperties
            } ${item.dimensionId.toString()}`
          : item.dimensionId.toString();
      } else {
        const replaceCategoryLink = this.searchRequest.searchFilterProperties
          ?.split(' ')
          .filter(
            a => a !== (this.searchRequest as FilterRequestModel).categoryId,
          )
          ?.reduce((a, b) => `${a} ${b}`, '')
          .trim();
        searchItems = !!replaceCategoryLink
          ? `${item.dimensionId.toString()} ${replaceCategoryLink}`
          : item.dimensionId.toString();
        this.searchRequest = {
          ...this.searchRequest,
          categoryId: item.dimensionId.toString(),
        } as FilterRequestModel;
      }
    } else if (!!searchItems) {
      searchItems = searchItems
        .split(' ')
        .filter(a => a !== item.dimensionId.toString())
        .reduce((a, b) => `${a} ${b}`, '')
        .trim();
    }

    this.searchRequest = {
      ...this.searchRequest,
      searchFilterProperties: searchItems,
    };
    if (this.timer) {
      clearTimeout(this.timer);
    }
    const searchFilterSelected: SearchFilterSelected = {
      filterNav: this.filterNav,
      refinementItem: item,
    };

    this.timer = setTimeout(() => {
      this.selectFilterOption.emit({
        ...this.searchRequest,
        searchFilterSelected,
      });
    }, 1000);

    // call fiter click analytics method
    this.searchFilterService.trackClickedSearchFilter(searchFilterSelected);
  }

  async showDisclaimer($event: any) {
    if (this.dialog.openDialogs.length !== 0) {
      this.hideDisclaimer();
      return;
    }
    this.renderer?.setStyle(
      this.triangle?.nativeElement,
      'display',
      'inline-flex',
    );

    const halfDisclaimerHeight = DISCLAIMER_HEIGHT / 2;
    let top =
      window.innerHeight - $event.clientY < halfDisclaimerHeight
        ? window.innerHeight - DISCLAIMER_HEIGHT
        : $event.clientY - halfDisclaimerHeight;

    let el = this.triangle.nativeElement;
    let x = -1;
    while (el && !isNaN(el.offsetLeft)) {
      x += el.offsetLeft - el.scrollLeft;
      el = el.offsetParent;
    }

    let left = x + this.triangle.nativeElement.clientWidth;
    document.addEventListener(
      'scroll',
      () => {
        this.hideDisclaimer();
      },
      true,
    );

    this.dialog.open(this.dialogTemplate, {
      hasBackdrop: false,
      autoFocus: true,
      closeOnNavigation: true,
      panelClass: 'disclaimer-panel',
      position: { top: top + 'px', left: left + 'px' },
      height: DISCLAIMER_HEIGHT + 'px',
      width: DISCLAIMER_WIDTH + 'px',
    });
  }

  hideDisclaimer() {
    this.renderer?.setStyle(this.triangle?.nativeElement, 'display', 'none');
    this.dialog.closeAll();
  }

  toggleRefinementView() {
    if (
      this.itemsToShow == this.DEFAULT_SHOW &&
      this.filterRefinements?.length > this.DEFAULT_SHOW
    ) {
      this.itemsToShow = this.filterRefinements?.length;
    } else {
      this.itemsToShow = this.DEFAULT_SHOW;
    }
  }

  getImageUrl(filter: SimpleRefinementItem): string {
    if (filter.name === '1 Star & Up') {
      return 'assets/images/1-star-rating.svg';
    } else if (filter.name === '2 Stars & Up') {
      return 'assets/images/2-star-rating.svg';
    } else if (filter.name === '3 Stars & Up') {
      return 'assets/images/3-star-rating.svg';
    } else if (filter.name === '4 Stars & Up') {
      return 'assets/images/4-star-rating.svg';
    } else if (filter.name === '5 Stars') {
      return 'assets/images/5-star-rating.svg';
    } else {
      return '';
    }
  }
}
